module.exports = __webpack_public_path__ + "assets/img/system-point-banner3.8d2a28d0.png";